import { apiCms } from '../../config/constants';

// eslint-disable-next-line prefer-destructuring
const DEFAULT_LANG = process.env.DEFAULT_LANGUAGES;

export default class Directus {
  static getLinkImage = (id, extention = '') =>
      `${ process.env.REACT_APP_CMS }/assets/${ id }${ extention }`

  static getFilterLink = ([key, value], parentKey = '') => {
      if (!key) return '';
      if (value === true) {
          return `${ parentKey }${ key === '*' ? '*' : `${ key }` }`;
      }
      const fullKey = `${ parentKey }${ key }.`;

      const res = Object.entries(value).map((i) =>
          Directus.getFilterLink(i, fullKey));

      return res.join(',');
  }

  static generate(collection, options) {
      const link = `${ apiCms }/items/${ collection }`;

      if (!options) return link;

      const { filter, fields } = options;

      const fieldsLink = fields
          ? Object.entries(fields)
              .map((field) => Directus.getFilterLink(field))
              .join(',')
          : '';
      if (!filter) return `${ link }?fields=${ fieldsLink }`;
      if (!fields) return `${ link }?filter=${ filter }`;

      return `${ link }?fields=${ fieldsLink }&filter${ filter }`;
  }

  static getTranslationByLang = (
      items,
      // directun translation items with languages_code property
      language,
      requireds
      // arrya of strings with required fields name(there are cases that we have item with particular language, but without all required fields)
  ) => {
      const finded = items.find((i) => i.languages_code === language);
      if (finded && !requireds) return finded;

      const returnDefault = () =>
          items.find((i) => i.languages_code === DEFAULT_LANG) || items[0];

      if (finded && Array.isArray(requireds) && requireds.length) {
          const hasAll = !requireds.find((property) => !finded[property]);
          return hasAll ? finded : returnDefault();
      }
      return returnDefault();
  }
}



// WEBPACK FOOTER //
// ./src/components/helpers/directusLink.js